import { useState, useCallback } from 'react';

export default () => {
  const [activeCalls, setActiveCalls] = useState<API.Call[]>([]);
  const [currentCall, setCurrentCall] = useState<API.Call | null>(null);
  const [callLogs, setCallLogs] = useState<API.CallLog[]>([]);

  const addCall = useCallback((call: API.Call) => {
    setActiveCalls((prev) => [...prev, call]);
  }, []);

  const updateCall = useCallback((idOrSid: string | number, updates: Partial<API.Call>) => {
    setActiveCalls((prev) =>
      prev.map((call) =>
        call.id === idOrSid || call.callSid === idOrSid ? { ...call, ...updates } : call,
      ),
    );
    if (currentCall?.id === idOrSid || currentCall?.callSid === idOrSid) {
      setCurrentCall((prev) => (prev ? { ...prev, ...updates } : null));
    }
  }, [currentCall]);

  const removeCall = useCallback((idOrSid: string | number) => {
    setActiveCalls((prev) =>
      prev.filter((call) => call.id !== idOrSid && call.callSid !== idOrSid),
    );
    if (currentCall?.id === idOrSid || currentCall?.callSid === idOrSid) {
      setCurrentCall(null);
    }
  }, [currentCall]);

  const addCallLog = useCallback((log: API.CallLog) => {
    setCallLogs((prev) => [log, ...prev]);
  }, []);

  return {
    activeCalls,
    currentCall,
    callLogs,
    setActiveCalls,
    setCurrentCall,
    setCallLogs,
    addCall,
    updateCall,
    removeCall,
    addCallLog,
  };
};

